import React from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import Building from "../../Assets/Image/building.png";
import Employee1 from "../../Assets/Image/Employee1.png";
import Employee2 from "../../Assets/Image/Employee2.png";
import Teknisi1 from "../../Assets/Image/Teknisi6.jpg";
import Lan from "../../Assets/Image/Lan.png";
import Itimplement from "../../Assets/Image/Itimplement.jpg";
import Itoperation from "../../Assets/Image/Itoperation.jpg";
import Assessment from "../../Assets/Image/assessment.png";
import Hardware from "../../Assets/Image/HardwareIntegration.png";

const serviceHighlights = [
  {
    title: "IT Consulting",
    description:
      "Strategic advisory to align technology investments with business objectives, operational priorities, and future growth.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7" aria-hidden="true">
        <path
          d="M4 19h16M6 16V8m6 8V5m6 11v-6"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    title: "Cybersecurity",
    description:
      "Security assessment, protection, monitoring, and remediation services designed to reduce technology and business risk.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7" aria-hidden="true">
        <path
          d="m12 3 7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m9 12 2 2 4-4"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Infrastructure",
    description:
      "Reliable infrastructure services covering hardware, networking, virtualization, cloud, and system integration.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7" aria-hidden="true">
        <rect x="3" y="4" width="18" height="6" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <rect x="3" y="14" width="18" height="6" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M7 7h.01M7 17h.01" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Managed Services",
    description:
      "Continuous operational support to maintain availability, performance, security, and service quality across IT environments.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="h-7 w-7" aria-hidden="true">
        <path
          d="M4 13a8 8 0 1 1 16 0v5a2 2 0 0 1-2 2h-2v-7h4M4 13h4v7H6a2 2 0 0 1-2-2v-5Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const services = [
  {
    eyebrow: "Advisory & Strategy",
    title: "IT Consulting",
    description:
      "Our IT consulting services help organizations improve performance, scalability, resilience, and competitiveness through the right technology strategy and implementation approach.",
    image: Teknisi1,
    imageAlt: "Viktorindo IT consulting service",
    features: [
      "IT strategy and technology roadmap",
      "Enterprise architecture planning",
      "Operational efficiency assessment",
      "Performance and capability improvement",
    ],
  },
  {
    eyebrow: "Cloud & Modern Infrastructure",
    title: "Virtualization and Cloud Solutions",
    description:
      "Transform traditional IT environments into more flexible and efficient platforms. We help organizations support diverse workloads, applications, and deployment models across on-premise and cloud environments.",
    image: Employee2,
    imageAlt: "Virtualization and cloud solutions",
    features: [
      "Server and infrastructure virtualization",
      "Private and hybrid cloud architecture",
      "Workload migration and optimization",
      "Business continuity and resource efficiency",
    ],
    dark: true,
  },
  {
    eyebrow: "Network Services",
    title: "DDI Solutions",
    description:
      "Integrated DNS, DHCP, and IP address management capabilities simplify network administration, improve visibility, support automation, and strengthen security across increasingly distributed environments.",
    image: Employee1,
    imageAlt: "DDI network solutions",
    features: [
      "DNS, DHCP, and IP address management",
      "Centralized network visibility",
      "Automated network administration",
      "Support for multi-cloud and multi-device environments",
    ],
  },
  {
    eyebrow: "Connectivity",
    title: "LAN/WAN Management",
    description:
      "We design and manage secure, reliable, and high-performance wired and wireless network infrastructure to ensure consistent access to critical applications and services.",
    image: Lan,
    imageAlt: "LAN and WAN management",
    features: [
      "LAN and WAN architecture",
      "Wireless network solutions",
      "Network monitoring and optimization",
      "Secure connectivity for branch and enterprise environments",
    ],
    dark: true,
  },
  {
    eyebrow: "Application & Delivery",
    title: "Application System and IT Implementation",
    description:
      "We help customers plan, develop, test, implement, and maintain application systems that support operational activities, improve productivity, and accelerate digital business processes.",
    image: Itimplement,
    imageAlt: "Application system and IT implementation",
    features: [
      "Business application development",
      "System implementation and deployment",
      "Testing and quality assurance",
      "Integration with existing business systems",
    ],
  },
  {
    eyebrow: "Security Assurance",
    title: "Vulnerability Assessment",
    description:
      "A structured security review designed to identify weaknesses, evaluate risk severity, and provide practical recommendations for remediation or mitigation.",
    image: Assessment,
    imageAlt: "Vulnerability assessment service",
    features: [
      "Security weakness identification",
      "Risk and severity classification",
      "Technical remediation recommendations",
      "Improved security posture and compliance readiness",
    ],
    dark: true,
  },
  {
    eyebrow: "Operational Excellence",
    title: "IT Operations Management",
    description:
      "We support the management of IT services and the infrastructure behind them, including operational control, monitoring, facilities coordination, and continuous service improvement.",
    image: Itoperation,
    imageAlt: "IT operations management",
    features: [
      "Infrastructure and service monitoring",
      "Operational control and incident support",
      "Performance and availability management",
      "Continuous service improvement",
    ],
  },
  {
    eyebrow: "System Integration",
    title: "Hardware and Integration",
    description:
      "We provide hardware supply, deployment, configuration, and integration services to ensure that technology components and business systems can communicate and operate effectively as one environment.",
    image: Hardware,
    imageAlt: "Hardware and system integration",
    features: [
      "Enterprise hardware deployment",
      "Multi-system integration",
      "Installation and configuration",
      "Testing, handover, and operational support",
    ],
    dark: true,
  },
];

export default function Service() {
  React.useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <main className="overflow-hidden bg-white text-slate-900">
      {/* Hero */}
      <section className="px-4 pt-4 sm:px-6 lg:px-8">
        <div
          className="relative min-h-[620px] overflow-hidden rounded-[28px] bg-cover bg-center shadow-[0_30px_80px_rgba(15,44,72,0.22)] lg:min-h-[690px]"
          style={{ backgroundImage: `url(${Building})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#071C33]/95 via-[#123A60]/88 to-[#123A60]/35" />
          <div className="absolute -right-32 top-20 h-96 w-96 rounded-full bg-[#2392D0]/20 blur-3xl" />
          <div className="absolute -bottom-40 left-1/3 h-96 w-96 rounded-full bg-white/10 blur-3xl" />

          <div className="relative z-10 mx-auto flex min-h-[620px] max-w-7xl items-center px-6 py-24 sm:px-10 lg:min-h-[690px] lg:px-16">
            <div className="max-w-3xl" data-aos="fade-up">
              <div className="mb-6 inline-flex items-center gap-3 rounded-full border border-white/20 bg-white/10 px-4 py-2 backdrop-blur-md">
                <span className="h-2.5 w-2.5 rounded-full bg-[#42B6F5]" />
                <span className="text-sm font-semibold uppercase tracking-[0.18em] text-white/90">
                  Our Services
                </span>
              </div>

              <h1 className="text-4xl font-semibold leading-tight text-white sm:text-5xl lg:text-7xl">
                End-to-end IT services for
                <span className="block text-[#58BFF4]">secure business growth.</span>
              </h1>

              <p className="mt-7 max-w-2xl text-base leading-8 text-slate-200 sm:text-lg">
                From technology strategy and infrastructure implementation to
                cybersecurity and managed operations, Viktorindo delivers
                integrated services designed around real business needs.
              </p>

              <div className="mt-10 flex flex-col gap-4 sm:flex-row">
                <a
                  href="#service-portfolio"
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-[#2392D0] px-7 py-3.5 text-sm font-semibold text-white shadow-lg shadow-[#2392D0]/25 transition duration-300 hover:-translate-y-1 hover:bg-[#1D82BB]"
                >
                  Explore Our Capabilities
                  <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
                    <path
                      d="M12 5v14M6 13l6 6 6-6"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>

                <Link
                  to="/#contact"
                  className="inline-flex items-center justify-center rounded-full border border-white/30 bg-white/10 px-7 py-3.5 text-sm font-semibold text-white backdrop-blur-md transition duration-300 hover:bg-white hover:text-[#123A60]"
                >
                  Consult With Our Team
                </Link>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 right-0 hidden rounded-tl-[40px] border-l border-t border-white/15 bg-white/10 px-10 py-8 backdrop-blur-xl lg:block">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/60">
              Service Approach
            </p>
            <p className="mt-2 max-w-xs text-lg font-medium leading-7 text-white">
              Assess. Design. Implement. Secure. Operate.
            </p>
          </div>
        </div>
      </section>

      {/* Highlights */}
      <section className="mx-auto max-w-7xl px-5 py-24 sm:px-6 lg:px-8 lg:py-28">
        <div className="mx-auto max-w-3xl text-center" data-aos="fade-up">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
            Integrated Capabilities
          </p>
          <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
            One technology partner across strategy, security, and operations.
          </h2>
          <p className="mt-6 leading-8 text-slate-600">
            Our services are designed to work together, helping customers reduce
            complexity while improving performance, security, and service quality.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {serviceHighlights.map((item, index) => (
            <article
              key={item.title}
              className="group rounded-[24px] border border-slate-200 bg-white p-7 shadow-sm transition duration-300 hover:-translate-y-2 hover:shadow-[0_24px_60px_rgba(18,58,96,0.14)]"
              data-aos="fade-up"
              data-aos-delay={index * 80}
            >
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E8F5FC] text-[#2392D0] transition duration-300 group-hover:bg-[#2392D0] group-hover:text-white">
                {item.icon}
              </div>
              <h3 className="mt-6 text-xl font-semibold text-[#123A60]">
                {item.title}
              </h3>
              <p className="mt-4 leading-7 text-slate-600">
                {item.description}
              </p>
            </article>
          ))}
        </div>
      </section>

      {/* Service portfolio */}
      <section id="service-portfolio" className="bg-[#F4F8FC] py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
          <div className="max-w-3xl" data-aos="fade-up">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
              Service Portfolio
            </p>
            <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
              Practical solutions for modern enterprise technology.
            </h2>
            <p className="mt-6 leading-8 text-slate-600">
              Each service can be delivered independently or combined into a
              broader transformation, implementation, or managed service program.
            </p>
          </div>

          <div className="mt-16 space-y-8">
            {services.map((service, index) => (
              <article
                key={service.title}
                className={`overflow-hidden rounded-[30px] border shadow-[0_20px_60px_rgba(18,58,96,0.10)] ${
                  service.dark
                    ? "border-[#1C527F] bg-[#123A60] text-white"
                    : "border-slate-200 bg-white text-slate-900"
                }`}
                data-aos="fade-up"
              >
                <div
                  className={`grid lg:grid-cols-2 ${
                    index % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
                  }`}
                >
                  <div className="relative min-h-[340px] overflow-hidden lg:min-h-[500px]">
                    <img
                      src={service.image}
                      alt={service.imageAlt}
                      className="absolute inset-0 h-full w-full object-cover transition duration-700 hover:scale-105"
                    />
                    <div
                      className={`absolute inset-0 ${
                        service.dark
                          ? "bg-gradient-to-t from-[#071C33]/55 via-transparent to-transparent"
                          : "bg-gradient-to-t from-[#123A60]/35 via-transparent to-transparent"
                      }`}
                    />
                  </div>

                  <div className="flex flex-col justify-center p-7 sm:p-10 lg:p-14">
                    <p
                      className={`text-sm font-bold uppercase tracking-[0.2em] ${
                        service.dark ? "text-[#58BFF4]" : "text-[#2392D0]"
                      }`}
                    >
                      {service.eyebrow}
                    </p>

                    <h3
                      className={`mt-4 text-3xl font-semibold leading-tight sm:text-4xl ${
                        service.dark ? "text-white" : "text-[#123A60]"
                      }`}
                    >
                      {service.title}
                    </h3>

                    <p
                      className={`mt-6 leading-8 ${
                        service.dark ? "text-slate-200" : "text-slate-600"
                      }`}
                    >
                      {service.description}
                    </p>

                    <ul className="mt-8 space-y-4">
                      {service.features.map((feature) => (
                        <li
                          key={feature}
                          className={`flex gap-3 text-sm leading-7 sm:text-base ${
                            service.dark ? "text-slate-200" : "text-slate-600"
                          }`}
                        >
                          <span className="mt-1.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-[#2392D0]">
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              className="h-3.5 w-3.5"
                              aria-hidden="true"
                            >
                              <path
                                d="m7 12 3 3 7-7"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Delivery approach */}
      <section className="mx-auto max-w-7xl px-5 py-24 sm:px-6 lg:px-8 lg:py-32">
        <div className="grid gap-14 lg:grid-cols-[0.8fr_1.2fr] lg:items-center">
          <div data-aos="fade-right">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#2392D0]">
              Delivery Method
            </p>
            <h2 className="mt-4 text-3xl font-semibold leading-tight text-[#123A60] sm:text-4xl lg:text-5xl">
              A structured approach from requirement to operation.
            </h2>
            <p className="mt-6 leading-8 text-slate-600">
              We combine technical expertise, clear project governance, and
              collaborative communication to deliver solutions that are ready
              for real operational use.
            </p>
          </div>

          <div className="grid gap-5 sm:grid-cols-2" data-aos="fade-left">
            {[
              ["01", "Assess", "Understand business goals, current conditions, risks, and technical requirements."],
              ["02", "Design", "Build an architecture and implementation plan aligned with operational priorities."],
              ["03", "Implement", "Deploy, configure, integrate, test, and document the agreed solution."],
              ["04", "Operate", "Provide support, monitoring, maintenance, and continuous service improvement."],
            ].map(([number, title, description]) => (
              <article
                key={number}
                className="rounded-[24px] border border-slate-200 bg-white p-6 shadow-sm"
              >
                <span className="text-sm font-bold tracking-[0.16em] text-[#2392D0]">
                  {number}
                </span>
                <h3 className="mt-4 text-xl font-semibold text-[#123A60]">
                  {title}
                </h3>
                <p className="mt-3 leading-7 text-slate-600">
                  {description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="px-4 pb-24 sm:px-6 lg:px-8 lg:pb-32">
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[30px] bg-gradient-to-r from-[#123A60] to-[#2173AA] px-6 py-14 sm:px-10 lg:flex lg:items-center lg:justify-between lg:px-14">
          <div className="absolute -right-12 -top-24 h-72 w-72 rounded-full border border-white/10" />
          <div className="absolute -right-4 -top-14 h-52 w-52 rounded-full border border-white/10" />

          <div className="relative z-10 max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#78CDF8]">
              Start a Conversation
            </p>
            <h2 className="mt-3 text-3xl font-semibold leading-tight text-white sm:text-4xl">
              Looking for the right solution for your IT environment?
            </h2>
            <p className="mt-4 leading-7 text-slate-200">
              Share your objectives and challenges with our team. We will help
              identify the most appropriate service and implementation approach.
            </p>
          </div>

          <div className="relative z-10 mt-8 lg:mt-0">
            <Link
              to="/#contact"
              className="inline-flex items-center justify-center gap-3 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-[#123A60] transition duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              Contact Our Team
              <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
                <path
                  d="M5 12h14M13 6l6 6-6 6"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}